module.exports = __webpack_public_path__ + "static/img/1.4e9a482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/1.png
// module id = I0t2
// module chunks = 1